import React, {useState} from 'react'
import "./Gallery.css";
import imgHeader from "../../assets/image/img-header.png";
import { Helmet } from 'react-helmet';
import {
  Anggota,
  Header,
  Banner,
  Good,
  Foto,
  Runner,
  Divider,
} from "../../components/joinComponents";

const Gallery = () => {
    const header = {
      title: "Gallery",
      description: "Kampung Mundu",
      img: imgHeader,
    };

    return (
      <>
        <Helmet>
          <title>
            Gallery Kami: Dengan segala macam kegiatan yang kami lakukan,
            tentunya akan kami sajikan dalam bentuk media untuk menjadi motivasi
            bagi warga lain.
          </title>
          <meta
            name='keyword'
            content='mundu, mundu 1902, moendoe, moendoe 1902, kampung digital, website desa, web keren, lubang buaya, jakarta timur, kampung keren'
          />
          <meta
            name='description'
            content='Gallery yang kita tampilkan berisi kegiatan sehari-hari ataupun agenda bulanan dari aktivitas warga kami.'
          />
          <meta
            name='og:title'
            content='Gallery Kami: Dengan segala macam kegiatan yang kami lakukan, tentunya akan kami sajikan dalam bentuk media untuk menjadi motivasi bagi warga lain.'
          />
          <meta
            name='og:description'
            content='Gallery yang kita tampilkan berisi kegiatan sehari-hari ataupun agenda bulanan dari aktivitas warga kami.'
          />
        </Helmet>
        <Header data={header} />

        <section className='container-gallery w-full lg:px-10 sm:px-5'>
          <div className='box-gallery flex flex-col lg:mt-16 sm:mt-5'>
            <p className='title-history w-fit lg:ml-16 sm:ml-5 md:ml-16 p-3 lg:text-7xl md:text-5xl'>
              Gallery Kegiatan
            </p>
            <p className='title-history w-fit p-3 lg:text-7xl md:text-5xl'>
              Kampung Mundu
            </p>
          </div>
          <div className='article-gallery w full grid lg:grid-flow-col gap-5 lg:auto-cols-auto'>
            <div className='col-grid-artc'>
              <p className='content-article-gallery  mt-10 text-3xl'>
                Setiap foto menceritakan kisahnya sendiri. Jelajahi galeri ini
                untuk mendengar cerita-cerita yang tak terlupakan dan
                momen-momen yang menginspirasi dari sepanjang perjalanan kami.
              </p>
              <p className='content-article-gallery mt-5 text-3xl'>
                Foto-foto ini bukan hanya gambar, tetapi suara dari
                kegiatan-kegiatan kami. Setiap gambar mewakili bagian unik dari
                narasi kami yang terus berkembang.
              </p>
            </div>
            <Foto />
          </div>
          <Divider />
          <Runner />
          <Good />
        </section>
      </>
    );
}

export default Gallery;
